import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import groupValidation from './groupValidation';
import * as GroupActions from 'redux/modules/groups';
import { LinkContainer } from 'react-router-bootstrap';
import { routeActions } from 'react-router-redux';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({
		created: state.groups.created,
		groupCreatedError: state.groups.groupCreatedError,
	}),
	dispatch => bindActionCreators({ ...GroupActions, ...routeActions }, dispatch)
)
@reduxForm({
	form: 'createGroupForm',
	fields: ['id', 'c_id', 'name'],
	validate: groupValidation,
	destroyOnUnmount: false
})
export default class CreateGroupForm extends Component {


	render() {
		const {
			fields: { id, c_id, name },
			formKey,
			handleSubmit,
			invalid,
			submitting,
			resetForm,
			createGroup,
			values,
			groupCreatedError,
			created,
			t
		} = this.props;

		const styles = require('containers/Groups/AddGroup.scss');



		if (groupCreatedError) {
			var error = (
				<div className="alert alert-danger" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
					{groupCreatedError}
				</div>);
		} else {
			var error = '';
		}

		var cid = this.props.urlParams.cid;
		var listUrl = this.props.urlParams.role == 'admin' ? '/admin/groups/' + cid : '/client/groups';

		if (created == true) {
			var success = (
				<div className="alert alert-success" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>

					{t('createGroupForm.group_is_created')}

					<LinkContainer to={listUrl}>
						<button className="btn btn-default" type="button">
							{t("main.back_to_grouplist")}							
						</button>
					</LinkContainer>
				</div>);
		} else {
			var success = '';
		}

		return (
			<form className="form-horizontal" >

				<div className="col-xs-6">
					<div className={'form-group' + (name.touched && name.error ? ' has-error' : '')}>
						<label className="col-xs-3 control-label">
							{t("createGroupForm.group_name")}
						</label>
						<div className={'col-xs-' + (name.touched && name.error ? '5' : '8')}>
							<input type="text" className="col-xs-8 form-control" placeholder="" {...name} />
						</div>
						{name.touched && name.error && <div className="col-xs-3 help-block">{name.error}</div>}
					</div>


					<button onClick={handleSubmit(() =>
						createGroup(values, this.props.urlParams).then(() => this.props.goBack())
					)} type="submit" className="btn btn-success" disabled={invalid || submitting}>
						<i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> &nbsp;
						
						{t("main.create_group")}
				  </button>
					{/*
	        <button type="button" className="btn btn-default" style={{ margin: 10 }} disabled={submitting} onClick={resetForm}>
	          Reset
	        </button>*/}
					&nbsp;
          			<LinkContainer to={listUrl}>
						<button className="btn btn-default" type="button">
							{t("main.back_to_grouplist")}
						</button>
					</LinkContainer>

					<br /><br />
					{error}
					{success}
				</div>


			</form>
		);
	}
}

